<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!-- begin: Single Modal -->
    <router-view />
    <!-- end: Single Modal -->
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }} <strong>{{ qiJobNumber }}</strong>
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-3 col-md-6">
              <div class="form-group mb-3">
                <label class="label mb-0"><strong>สถานะการดำเนินการ :</strong></label>
                <span class="form-control-plaintext" v-html="qiStatusName"></span>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="form-group mb-3">
                <label class="label mb-0"><strong>วันที่สร้าง :</strong></label>
                <span class="form-control-plaintext">{{ createdDate }}</span>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="form-group mb-3">
                <label class="label mb-0"><strong>วันที่ซ่อมเสร็จสิ้น</strong></label>
                <span class="form-control-plaintext">{{ finishedDate }}</span>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="form-group mb-3">
                <label class="label mb-0"><strong>ชื่อช่าง :</strong></label>
                <span class="form-control-plaintext">{{ createdUserName }}</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-3 col-md-6">
              <div class="form-group mb-3">
                <label class="label mb-0"><strong>ประเภทใบงาน :</strong></label>
                <span class="form-control-plaintext" v-html="qiTypeName"></span>
              </div>
            </div>
            <div v-if="qiSubType == 1" class="col-xl-3 col-md-6">
              <div class="form-group mb-3">
                <label class="label mb-0"><strong>BARCODE :</strong></label>
                <span class="form-control-plaintext">{{ barcodeNoOld }}</span>
              </div>
            </div>
            <div v-if="qiTypeCode !== 'JOB_QI_TYPE_DRAWBACK'" class="col-xl-3 col-md-6">
              <div class="form-group mb-3">
                <label class="label mb-0"><strong>ชื่อสินค้า/อุปกรณ์ :</strong></label>
                <span class="form-control-plaintext">{{ materialNameShow }}</span>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="form-group mb-3">
                <label class="label mb-0"><strong>จำนวน :</strong></label>
                <span class="form-control-plaintext">
                  {{ amount }}
                </span>
              </div>
            </div>
          </div>

          <div class="row">
            <div v-if="!qiAreaPlant" class="col-xl-6">
              <label class="label mb-0"><strong>สถานที่ซ่อมอุปกรณ์:</strong></label>
              <span class="form-control-plaintext">
                {{ 'ซ่อมในตัวแทนจำหน่าย' }} <strong>{{ agentCodeSap ? ' >> '+agentName+' ('+agentCodeSap+')' : ''}}</strong>
              </span>
            </div>
            <div v-else class="col-xl-3">
              <label class="label mb-0"><strong>สถานที่ซ่อมอุปกรณ์:</strong></label>
              <span class="form-control-plaintext">
                {{ 'ซ่อมที่คลังอุปกรณ์เบียร์สดปากเกร็ด' }} 
              </span>
            </div>
            <div class="col-xl-3 col-md-6" v-if="qiAreaPlant && qiTypeCode == 'JOB_QI_TYPE_REPAIR'" >
              <div class="form-group mb-3">
                <label class="label mb-0"><strong>วันที่รับเข้าคลังดี :</strong></label>
                <span class="form-control-plaintext">{{ confirmedDate }}</span>
              </div>
            </div>
            <div class="col-xl-3 col-md-6" v-if="qiAreaPlant && qiTypeCode == 'JOB_QI_TYPE_REPAIR'" >
              <div class="form-group mb-3">
                <label class="label mb-0"><strong>ผู้รับเข้าคลังดี :</strong></label>
                <span class="form-control-plaintext">{{ confirmedUserName }}</span>
              </div>
            </div>
          </div>

          <div class="kt-section kt-section--first">
            <div class="kt-section__body">
              <label class="label mb-0"><strong>อะไหล่สำหรับซ่อม/ล้าง :</strong></label>
              <span class="form-text mb-3"></span>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table class="table table-sm table-striped table-bordered table-checkable">
                    <thead>
                      <tr :class="qiSubType === 1 ? 'table-warning' : 'table-info'">
                        <th class="text-center" width="10%">ลำดับ</th>
                        <th class="text-center" width="30%">รายการ</th>
                        <th class="text-center" width="20%">จำนวน</th>
                        <th class="text-center" width="20%">ราคา/หน่วย</th>
                        <th class="text-center" width="20%">มูลค่ารวม</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, i) in items" :key="item.qiJobItemId">
                        <td class="text-center"><span class="form-control form-control-plaintext">{{ i + 1 }}</span></td>
                        <td>
                          <input type="text" v-model="item.materialNameShow" class="form-control" :disabled="!isDisable" />
                        </td>
                        <td>
                          <input type="number" v-model.number="item.quantity" :ref="`quantity-${i}`" class="form-control text-right" :disabled="!isDisable" />
                        </td>
                        <td>
                          <input type="number" v-model.number="item.unitPrice" :ref="`unitPrice-${i}`" class="form-control text-right" />
                          <span class="form-text text-danger">{{ errors.items[i] && errors.items[i].unitPrice ? errors.items[i].unitPrice : '' }}</span>
                        </td>
                        <td class="text-right">
                          <span class="form-control form-control-plaintext">
                            {{ (item.quantity * item.unitPrice || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" class="text-right p-3"><strong>รวมจำนวน/มูลค่ารวม</strong></td>
                        <td class="text-right">
                          <span class="form-control form-control-plaintext">
                              <strong>{{ totalQuantity.toLocaleString('en-US') }}</strong>
                          </span>
                        </td>
                        <td></td>
                        <td class="text-right">
                          <span class="form-control form-control-plaintext">
                            <strong>{{ totalValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</strong>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="form-group"></div>
              <label class="label mb-0"><strong>ค่าบริการ :</strong></label>
              <span class="form-text mb-3"></span>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table class="table table-sm table-striped table-bordered table-checkable">
                    <thead>
                      <tr :class="qiSubType === 1 ? 'table-warning' : 'table-info'">
                        <th class="text-center" width="10%">ลำดับ</th>
                        <th class="text-center" width="30%">รายการ</th>
                        <th class="text-center" width="20%">จำนวน</th>
                        <th class="text-center" width="20%">ราคา/หน่วย</th>
                        <th class="text-center" width="20%">มูลค่ารวม</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, i) in services" :key="item.qiJobServiceId">
                        <td class="text-center"><span class="form-control form-control-plaintext">{{ i + 1 }}</span></td>
                        <td>
                          <input type="text" v-model="item.serviceName" class="form-control" :disabled="!isDisable" />
                        </td>
                        <td>
                          <input type="number" v-model.number="item.quantity" :ref="`quantity-${i}`" class="form-control text-right" :disabled="!isDisable" />
                        </td>
                        <td>
                          <input type="number" v-model.number="item.unitPrice" :ref="`unitPriceService-${i}`" class="form-control text-right" />
                          <span class="form-text text-danger">{{ errors.services[i] && errors.services[i].unitPrice ? errors.services[i].unitPrice : '' }}</span>
                        </td>
                        <td class="text-right">
                          <span class="form-control form-control-plaintext">
                            {{ (item.quantity * item.unitPrice || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2" class="text-right p-3"><strong>รวมจำนวน/มูลค่ารวม</strong></td>
                        <td class="text-right">
                          <span class="form-control form-control-plaintext">
                              <strong>{{ totalQuantityService.toLocaleString('en-US') }}</strong>
                          </span>
                        </td>
                        <td></td>
                        <td class="text-right">
                          <span class="form-control form-control-plaintext">
                            <strong>{{ totalValueService.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</strong>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button type="submit" class="btn btn-primary" data-dismiss="modal">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../Shared/Select2";

export default {
  components: {
    select2,
  },
  data: function() {
    var self = this;
    return {
      qiJobId: null,
      qiJobNumber: null,
      qiStatusCode: null,
      qiTypeCode: '',
      qiSubType: 0,
      qiStatusName: null,
      qiAreaPlant: true,
      createdDate: null,
      createdUserName: null,
      finishedDate: null,
      confirmedDate: null,
      confirmedUserName: null,
      qiTypeName: null,
      barcodeNoOld: null,
      materialNameShow: null,
      amount: null,
      items: [],
      services: [],
      originalOptions: [],
      materialCodeOptions: {
        placeholder: "กรุณาเลือกสินค้า",
        allowClear: true,
      },
      errors: {
        items: [],
        services: []
      },
      isDisable: false,
    };
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    try {
      let response = await axios.get("/Api/QIJobs/" + this.$route.params.id, {
        params: {
          withFile: false
        }
      });
      if (response.status === 200 && response.data) {
        self.qiJobId = response.data.qiJobId;
        self.qiJobNumber = response.data.qiJobNumber ? `เลขที่ใบงาน : ${response.data.qiJobNumber}` : '';
        self.qiTypeCode = response.data.qiTypeCode;
        self.qiSubType = response.data.qiSubType;

        let qiStatusCode = response.data.qiStatusCode;
        let statusIcon = '';
        let statusText = self.qiStatusName = response.data.qiStatusName;
        if (qiStatusCode === "JOB_QI_STATUS_PENDING") {
          statusIcon = '<i class="fa fa-sync-alt"></i>';
        } else if (qiStatusCode === "JOB_QI_STATUS_REQUEST_APPROVAL") {
          statusIcon = '<i class="fa fa-file-signature"></i>';
        } else if (qiStatusCode === "JOB_QI_STATUS_REPAIR_COMPLETED") {
          statusIcon = '<i class="fa fa-check"></i>';
        } else if (qiStatusCode === "JOB_QI_STATUS_CANCEL") {
          statusIcon = '<i class="fa fa-ban text-danger"></i>';
        } else if (qiStatusCode == "JOB_QI_STATUS_SUCCESS") {
          statusIcon = '<i class="fa fa-check-circle"></i>';
        }
        self.qiStatusCode = qiStatusCode;
        self.qiStatusName = statusIcon + ' ' + statusText;

        self.barcodeNoOld = response.data.barcodeNoOld ? response.data.barcodeNoOld : '-';
        self.materialNameShow = response.data.materialNameShow ? response.data.materialNameShow : '-';
        self.qiAreaPlant = response.data.qiAreaPlant;

        self.createdDate = response.data.createdDateFormat || '-';
        self.createdUserName = response.data.createdUserName || '-';
        self.finishedDate = response.data.finishedDate && response.data.finishedUserId != null ? self.setDateFormat(response.data.finishedDate, true) : '-';
        self.confirmedDate = response.data.confirmedDate ? self.setDateFormat(response.data.confirmedDate, true) : '-';
        self.confirmedUserName = response.data.confirmedUserName || '-';

        let additionalText = '';
        if (response.data.qiTypeCode === "JOB_QI_TYPE_DRAWBACK" && response.data.finishedDate) {
          additionalText = response.data.qiSubType === 1 ? ' <span>(เบิก)</span>' : ' <span>(คืน)</span>';
        }
        self.qiTypeName = response.data.qiTypeName ? response.data.qiTypeName + additionalText : '-';
        self.amount = response.data.amount || '-';

        if (response.data.items && Array.isArray(response.data.items)) {
          if (response.data.qiTypeCode === "JOB_QI_TYPE_DRAWBACK") {
            self.amount = response.data.items.reduce((total, item) => total + item.quantity, 0);
          }
          self.items = response.data.items;
        }

        if (response.data.services && Array.isArray(response.data.services)) {
          self.services = response.data.services;
        }

      } else {
          throw new Error("ไม่พบข้อมูลใบงานช่างซ่อมคุณเลือก");
      }

    } catch (error) {
        Swal.fire("เกิดข้อผิดพลาด", error.message || "ระบบเกิดข้อผิดพลาด", "error");
        router.go(-1);
    } finally {
        KTApp.unblockPage();
    }
  },
  methods: {
    setDateFormat(dateStr, includeTime = false) {
      let options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        calendar: 'gregory'
      };
      if (includeTime) {
        options = {
          ...options,
          hour: '2-digit',
          minute: '2-digit'
        };
      }
      let dateStrFormat = new Date(dateStr).toLocaleDateString('th-TH', options);
      return dateStrFormat;
    },
    validateItems() {
      let isValid = true;

      this.errors.items = [];
      this.items.forEach((item, index) => {
        if (!item.unitPrice || item.unitPrice === 0) {
          isValid = false;
          this.$set(this.errors.items, index, { unitPrice: 'กรุณากรอกราคา/หน่วย' });
          this.$set(this.errors.items, index, { ...this.errors.items[index], unitPrice: 'กรุณาเลือกสินค้า' });
        } else {
          this.$set(this.errors.items, index, { ...this.errors.items[index], unitPrice: '' });
        }
      });

      this.errors.services = [];
      this.services.forEach((service, index) => {
        if (!service.unitPrice || service.unitPrice === 0) {
          isValid = false;
          this.$set(this.errors.services, index, { ...this.errors.services[index], unitPrice: 'กรุณากรอกราคา/หน่วย' });
        } else {
          this.$set(this.errors.services, index, { ...this.errors.services[index], unitPrice: '' });
        }
      });
      console.log(this.errors)
      return isValid;
    },
    formSubmit: function(e) {
      let router = this.$router;
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      if (!this.validateItems()) {
        return false;
      }

      if (this.items.length == 0) {
        Swal.fire(
          "",
          "กรุณาเพิ่มรายการอุปกรณ์",
          "warning"
        );
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/QIJobs/EditDrawback",
        data: {
          QIJobId: this.qiJobId,
          QIJobItems: this.items,
          QIJobService: this.services
        },
      })
      .then(function(response) {
        console.log(response)
        if (response.data.status) {
          Swal.fire("สำเร็จ", response.data.message, "success").then(
            function() {
              router.go(-1), self.$parent.reloadDataTable(false);
            }
          );
        } else {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        }
      })
      .catch(function(error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
    },
  },
  computed: {
    totalQuantity() {
      return this.items.reduce((sum, item) => sum + (item.quantity || 0), 0);
    },
    totalValue() {
      return this.items.reduce((sum, item) => sum + (item.quantity * item.unitPrice || 0), 0);
    },
    totalQuantityService() {
      return this.services.reduce((sum, item) => sum + (item.quantity || 0), 0);
    },
    totalValueService() {
      return this.services.reduce((sum, item) => {
        return sum + item.quantity * item.unitPrice;
      }, 0);
    },
  }
};
</script>



// WEBPACK FOOTER //
// App/Components/QIJob/QIJobEditRepair.vue